import { defineMessages } from '@dragonraider5/react-intl'

import { MAX_DATE, MIN_DATE } from '../../../../../utils/validations/constants'

export default defineMessages({
  [MAX_DATE]: {
    id: 'containers.Applications.steps.forms.validations.constitution_max_date',
    description: 'Message for validation constitution greater than today',
    defaultMessage: 'Lo sentimos, la fecha de constitución no puede ser mayor al día de hoy.'
  },
  [MIN_DATE]: {
    id: 'containers.Applications.steps.forms.validations.constitution_min_date',
    description: 'Message for expiration validation, it must be greater than today',
    defaultMessage: 'Lo sentimos, la fecha tiene que ser una fecha futura.'
  }
})
